import { ValidationError, NonJSONResponseError } from '../errors';
import { validateDialBody, validateDial200, validateConferenceStatus200, validateLock200, validateUnlock200, validateStartConference200, validateMuteguests200, validateUnmuteguests200, validateSetGuestsCanUnmuteBody, validateSetGuestsCanUnmute200, validateDisconnect200, validateMessageConferenceBody, validateMessageConference200, validateMessageConference404, validateParticipants200, validateTransformLayoutBody, validateTransformLayout200, validateClearAllBuzz200, validateSilentVideoDetectionBody, validateSilentVideoDetection200, validateTheme200, validateTheme204, validateAvailableLayouts200, validateLayoutSvgs200, validateGuestBreakoutBuzz200, validateGuestClearBreakoutBuzz200, validateVideoMixesCreateBody, validateVideoMixesCreate200, validateVideoMixesConfigureBody, validateVideoMixesConfigure200, validateVideoMixesDelete200, validateLiveCaptionsLanguages200, validateLiveCaptionsLanguages403, } from './validation';
export async function dial({ fetcher, init, params, body, host, }) {
    if (!validateDialBody(body)) {
        throw new ValidationError(validateDialBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/dial`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateDial200(data)) {
                throw new ValidationError(validateDial200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function conferenceStatus({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/conference_status`, {
        ...init,
        method: 'get',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateConferenceStatus200(data)) {
                throw new ValidationError(validateConferenceStatus200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function lock({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/lock`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateLock200(data)) {
                throw new ValidationError(validateLock200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function unlock({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/unlock`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateUnlock200(data)) {
                throw new ValidationError(validateUnlock200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function startConference({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/start_conference`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateStartConference200(data)) {
                throw new ValidationError(validateStartConference200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function muteguests({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/muteguests`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateMuteguests200(data)) {
                throw new ValidationError(validateMuteguests200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function unmuteguests({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/unmuteguests`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateUnmuteguests200(data)) {
                throw new ValidationError(validateUnmuteguests200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function setGuestsCanUnmute({ fetcher, init, params, body, host, }) {
    if (!validateSetGuestsCanUnmuteBody(body)) {
        throw new ValidationError(validateSetGuestsCanUnmuteBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/set_guests_can_unmute`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateSetGuestsCanUnmute200(data)) {
                throw new ValidationError(validateSetGuestsCanUnmute200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function disconnect({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/disconnect`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateDisconnect200(data)) {
                throw new ValidationError(validateDisconnect200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function messageConference({ fetcher, init, params, body, host, }) {
    if (!validateMessageConferenceBody(body)) {
        throw new ValidationError(validateMessageConferenceBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/message`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateMessageConference200(data)) {
                throw new ValidationError(validateMessageConference200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 404) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateMessageConference404(data)) {
                throw new ValidationError(validateMessageConference404.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function participants({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/participants`, {
        ...init,
        method: 'get',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateParticipants200(data)) {
                throw new ValidationError(validateParticipants200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function transformLayout({ fetcher, init, params, body, host, }) {
    if (!validateTransformLayoutBody(body)) {
        throw new ValidationError(validateTransformLayoutBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/transform_layout`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateTransformLayout200(data)) {
                throw new ValidationError(validateTransformLayout200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function clearAllBuzz({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/clearallbuzz`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateClearAllBuzz200(data)) {
                throw new ValidationError(validateClearAllBuzz200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function silentVideoDetection({ fetcher, init, params, body, host, }) {
    if (!validateSilentVideoDetectionBody(body)) {
        throw new ValidationError(validateSilentVideoDetectionBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/silent_video_detection`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateSilentVideoDetection200(data)) {
                throw new ValidationError(validateSilentVideoDetection200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function theme({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/theme/`, {
        ...init,
        method: 'get',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateTheme200(data)) {
                throw new ValidationError(validateTheme200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 204) {
        const data = await res.text();
        if (!validateTheme204(data)) {
            throw new ValidationError(validateTheme204.errors);
        }
        return { status: res.status, data };
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function availableLayouts({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/available_layouts?annotate=${encodeURIComponent(params.annotate)}`, {
        ...init,
        method: 'get',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateAvailableLayouts200(data)) {
                throw new ValidationError(validateAvailableLayouts200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function layoutSvgs({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/layout_svgs`, {
        ...init,
        method: 'get',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateLayoutSvgs200(data)) {
                throw new ValidationError(validateLayoutSvgs200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function guestBreakoutBuzz({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/breakoutbuzz`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateGuestBreakoutBuzz200(data)) {
                throw new ValidationError(validateGuestBreakoutBuzz200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function guestClearBreakoutBuzz({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/clearbreakoutbuzz`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateGuestClearBreakoutBuzz200(data)) {
                throw new ValidationError(validateGuestClearBreakoutBuzz200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function videoMixesCreate({ fetcher, init, params, body, host, }) {
    if (!validateVideoMixesCreateBody(body)) {
        throw new ValidationError(validateVideoMixesCreateBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/video_mixes/create`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateVideoMixesCreate200(data)) {
                throw new ValidationError(validateVideoMixesCreate200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function videoMixesConfigure({ fetcher, init, params, body, host, }) {
    if (!validateVideoMixesConfigureBody(body)) {
        throw new ValidationError(validateVideoMixesConfigureBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/video_mixes/${encodeURIComponent(params.mixName)}/configure`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateVideoMixesConfigure200(data)) {
                throw new ValidationError(validateVideoMixesConfigure200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function videoMixesDelete({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/video_mixes/${encodeURIComponent(params.mixName)}/delete`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateVideoMixesDelete200(data)) {
                throw new ValidationError(validateVideoMixesDelete200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function liveCaptionsLanguages({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/live_captions_languages`, {
        ...init,
        method: 'get',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateLiveCaptionsLanguages200(data)) {
                throw new ValidationError(validateLiveCaptionsLanguages200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateLiveCaptionsLanguages403(data)) {
                throw new ValidationError(validateLiveCaptionsLanguages403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
//# sourceMappingURL=index.js.map